import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styles from './GlobalLoader.module.scss';
import { useSelector } from 'react-redux';
const GlobalLoader = () => {
    const isLoaderShown = useSelector((state) => state.loader.isLoaderShown);
    const [visible, setVisible] = useState(false);
    useEffect(() => {
        if (isLoaderShown) {
            setVisible(true);
            document.body.style.overflow = 'hidden';
        }
        else {
            const timer = setTimeout(() => {
                setVisible(false);
                document.body.style.overflow = '';
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [isLoaderShown]);
    if (!visible)
        return null;
    return createPortal(_jsx("div", Object.assign({ className: `${styles.loader__container} ${isLoaderShown ? styles.show : styles.hide}`, "data-testid": "global-loader" }, { children: _jsx("div", { className: styles.loader }) })), document.body);
};
export default GlobalLoader;
